import React from 'react';
import  AvidReaders2025  from 'views/AvidReaders2025';

const DesktopAppPage = () => {
  return <AvidReaders2025/>;
};
export default DesktopAppPage;
